import config from 'baseConfig/pg/suspicious';

export default {
  TABLE_COLUMNS: [
    {
      // key: 'txTime',
      key: 'riskyAddedOn',
      displayName: 'Created On',
      width: 1.5,
      tooltip: {
        message: 'Suspicious Transaction Added On',
      },
    },
    ...config.TABLE_COLUMNS,
  ],
  FILTER_ITEMS: {},
  SEARCH_ITEMS: {},
};
